<template>
  <base-dialog
    v-model="dialog"
  >
    <template v-slot:title>
      <v-icon icon="mdi-check-decagram" color="primary"></v-icon>
      {{ $t('verify.dialog.title') }}
    </template>

    <template v-slot:content v-if="!showCode">
      <div class="text-center">
          <v-row
              v-for="(el, i) in $tm(['verify.dialog.modList'])"
              :key="i"
              no-gutters=""
              class="mb-2 description-row"
          >
            <v-col sm="auto" class="mr-2 color-primary number-col">
              {{ i+1 }}.
            </v-col>
            <v-col class="text-start">
              <span v-html="$rt(el)"></span>
            </v-col>
          </v-row>
        </div>
    </template>

    <template v-slot:content v-else>
      <div class="text-center">
        <v-row
          v-for="(el, i) in $tm(['verify.dialog.list'])"
          :key="i"
          no-gutters=""
          class="mb-2 description-row"
        >
          <v-col sm="auto" class="mr-2 color-primary number-col">
            {{ i+1 }}.
          </v-col>
          <v-col class="text-start">
            <span v-html="$rt(el)"></span>
          </v-col>
        </v-row>
        <copy-text-field :input="'!verify ' + code" label="Command"/>
      </div>
      <count-down
        class="mt-3"
        :time="codeValidMs / 1000"
        font-size="42px"
        @done="refreshCode"
      />
    </template>

    <template v-slot:actions>
      <kicklet-button :text="showCode ? $t('dialog.ok') : $t('dialog.continue')" @click="continueDialog()"/>
    </template>
  </base-dialog>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { Backend } from '@/services/Backend';
import CountDown from '@/components/CountDown';
import BaseDialog from '@/components/dialog/BaseDialog';
import { WS } from '@/services/WS';
import { useStore } from 'vuex';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import CopyTextField from '@/components/custom/CopyTextField.vue';

const store = useStore();

const props = defineProps({
  modelValue: Boolean,
  closable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const dialog = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val);
  },
});

const showCode = ref(false);

const code = ref(null);
const codeValidMs = ref(0);

function refreshCode () {
  dialog.value = false;
  showCode.value = false;
  nextTick(() => {
    showCode.value = true;
    dialog.value = true;
  });
}

function continueDialog () {
  if (showCode.value) {
    dialog.value = false;
    showCode.value = false;
  } else {
    showCode.value = true;
  }
}

watch(() => showCode.value, () => {
  if (showCode.value === true) {
    Backend.getVerifyCode()
      .then(response => {
        const data = response.data;
        code.value = data.code;
        codeValidMs.value = data.validMs;
      }).catch(err => Backend.handleError(err));
  }
});

onMounted(() => {
  WS.init()
    .then(() => {
      WS.subscribe([`user/${store.getters.userId}/auth/verify`]);
      WS.on(`user/${store.getters.userId}/auth/verify`, handleVerify);
    });
});

onBeforeUnmount(() => {
  WS.off(`user/${store.getters.userId}/auth/verify`, handleVerify);
});

function handleVerify (event) {
  Backend.refreshCookie().then(() => {
    showCode.value = false;
  }).catch(err => Backend.handleError(err));
}
</script>

<style scoped>
.code {
  padding: 20px;
  font-size: 18px;
}
.description-row {
  font-size: 14px;
}
.number-col {
  max-width: 16px;
}
</style>
